import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { faqs } from '../data/mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Reveal, SectionHeading } from './Reveal';
import { BOOKING_URL, CTA_LABEL } from '../data/constants';

const FAQSection = () => (
  <section id="faq" className="relative bg-cream py-24 lg:py-32 overflow-hidden" data-testid="faq-section">
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-4">
        <SectionHeading
          align="left"
          eyebrow="FAQ"
          title={<>Fragen, die wir <span className="text-violet-gradient">täglich hören.</span></>}
          subtitle="Alles Wichtige zu Ablauf, Festpreis und Garantie. Nicht dabei? Ruf uns einfach an."
        />
        <Reveal delay={0.2} className="mt-10 lux-card-dark p-6 text-white" data-testid="faq-contact-card">
          <p className="text-sm text-slate-400">Direkt sprechen?</p>
          <a href="tel:+4915167026918" className="mt-2 flex items-center gap-3 text-lg font-display font-bold hover:text-amber-300 transition-colors">
            <Phone className="w-5 h-5 text-amber-400" /> +49 151 670 269 18
          </a>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-gold mt-6 w-full px-5 py-3 text-sm text-center" data-testid="faq-cta">
            {CTA_LABEL} <ArrowRight className="w-4 h-4" />
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={f.id} value={`item-${f.id}`} className="lux-card px-6 border data-[state=open]:border-amber-400/60" data-testid={`faq-item-${f.id}`}>
              <AccordionTrigger className="py-5 text-left hover:no-underline group gap-4">
                <span className="flex items-start gap-4">
                  <span className="font-display text-xs font-bold text-amber-500 tracking-[0.2em] mt-1.5">0{i + 1}</span>
                  <span className="text-slate-900 font-semibold text-base md:text-lg group-hover:text-violet-700 transition-colors">{f.question}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-10 text-slate-600 leading-relaxed text-sm md:text-base">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default FAQSection;
